export enum CourseSelectionActions {
  DRAG_COURSE = "DRAG_COURSE",
  DELETE_COURSE = "DELETE_COURSE",
  DELETE_ALL_COURSES = "DELETE_ALL_COURSES",
  EMPTY_ALL_SEMESTERS = "EMPTY_ALL_SEMESTERS",
  SET_ISLOADING = "SET_ISLOADING",
  SET_PROGRAM = "SET_PROGRAM",
  SET_DRAGGING_COURSE_ID = "SET_DRAGGIN_COURSE_ID",
  SET_SEARCH_MODE = "SET_SEARCH_MODE",
  ADD_COURSE = "ADD_COURSE",
  SET_SEMESTERS = "SET_SEMESTERS",
  UPDATE_COURSE_LINEUP_FOR_ORIENTATION = "UPDATE_COURSE_LINEUP_FOR_ORIENTATION",
  SET_SEMESTER_SEASON = "SET_SEMESTER_SEASON",
}
